import { devices } from '@helpers/utils.js';

const BackgroundTypeGradientSave = ({
  backgroundGradientOptions,
  blockId,
  defaultBlockCssClass,
  printBackgroundStyles,
}) => {
  return (
    <style>
      {devices.map((device) => {
        const deviceType = device.type;
        const gradientSettings = backgroundGradientOptions[deviceType].settings;
        const gradientDirection = gradientSettings.gradientDirection || '';
        const gradientColorOne = gradientSettings.gradientColorOne || '';
        const gradientColorTwo = gradientSettings.gradientColorTwo || '';
        const gradientColorOneLocation =
          gradientSettings.gradientColorOneLocation !== undefined
            ? `${gradientSettings.gradientColorOneLocation}%`
            : '';
        const gradientColorTwoLocation =
          gradientSettings.gradientColorTwoLocation !== undefined
            ? `${gradientSettings.gradientColorTwoLocation}%`
            : '';

        let cssCode = '';
        const printQuery = printBackgroundStyles
          ? `, print and (max-width: ${backgroundGradientOptions[deviceType].breakpoint}px)`
          : ``;

        if (gradientColorOne && gradientColorTwo) {
          cssCode = `@media only screen and (max-width: ${backgroundGradientOptions[deviceType].breakpoint}px)${printQuery} {
						.${defaultBlockCssClass}.${defaultBlockCssClass}-${blockId} {
							background-image: linear-gradient(${gradientDirection}deg, ${gradientColorOne} ${gradientColorOneLocation}, ${gradientColorTwo} ${gradientColorTwoLocation});
						}
					}`;
        }

        return cssCode;
      })}
    </style>
  );
};

export default BackgroundTypeGradientSave;
